import React, { useContext, useMemo, useState } from "react";
import { FullSessionList } from "./fullSessionList/FullSessionList";
import { AddSession } from "./addSession/AddSession";
import { ISession } from "../../../../types/dashboard";
import { AppContext } from "../../../../appContext";
import { formatDate1 } from "../../../../utils/dateFormats";
import { DashboardContext } from "../../DashboardContext";

export const FullSessions = () => {
    const [activePopup, setActivePopup] = useState('FullSessionList');
    const [selectedSessionForEdit, setSelectedSessionForEdit] = useState<ISession>(null);
    const dashboardContext = useContext(DashboardContext);
    const {
        selectedClientId,
        selectedClient,
        editSession,
        deleteSession: _deleteSession
    } = dashboardContext;

    // Эффект для автоматического открытия сессии, если она была передана через контекст
    React.useEffect(() => {
        if (dashboardContext.setSelectedSessionForEdit && selectedClient) {
            // Проверяем, есть ли сессия для автоматического открытия в localStorage или другом месте
            const sessionIdToOpen = localStorage.getItem('openSessionId');
            if (sessionIdToOpen) {
                const sessionToOpen = selectedClient.sessions?.find(s => s.id === sessionIdToOpen);
                if (sessionToOpen) {
                    setSelectedSessionForEdit(sessionToOpen);
                    setActivePopup('AddSession');
                    localStorage.removeItem('openSessionId'); // Очищаем после использования
                }
            }
        }
    }, [selectedClient, dashboardContext.setSelectedSessionForEdit]);

    const contextData = useContext(AppContext);
    const clientsData = contextData.clients || [];
    const { translate, currentLanguage } = contextData;

    const clients = useMemo(() => clientsData.map(it => {
        return {
            id: it.id,
            name: it.name,
            date1: it.sessions?.[0] ? formatDate1(new Date(it.sessions[0]?.date), translate, currentLanguage) : '',
            date2: it.sessions?.[1] ? formatDate1(new Date(it.sessions[1]?.date), translate, currentLanguage) : '',
            avatarUrl: it.avatarUrl,
            waitLoading: it.waitLoading
        }
    }), [clientsData, translate, currentLanguage]);

    const selectedClientSessionsArray = useMemo(()=>{
        if (!selectedClient?.sessions){
            return [];
        }
        // Return all sessions including temporary ones for proper display
        return selectedClient.sessions;
    }, [selectedClient?.sessions]);

    return <>
        {
            activePopup == 'AddSession' && <AddSession
                clients={clients}
                sessionData={selectedSessionForEdit}
                onClose={() => {
                    setActivePopup('FullSessionList');
                    setSelectedSessionForEdit(null);
                }}
                onDelete={(sessionData) => {
                    setActivePopup('FullSessionList');
                    _deleteSession(sessionData);
                    setSelectedSessionForEdit(null);
                }}
                onSave={(sessionData) => {
                    setActivePopup('FullSessionList');
                    editSession(sessionData);
                    setSelectedSessionForEdit(null);
                }}
                onSaveDraft={() => {
                    setActivePopup('FullSessionList');
                    setSelectedSessionForEdit(null);
                }}
                defaultClientId={selectedClientId}
            ></AddSession>
        }
        {
            activePopup == 'FullSessionList' && <FullSessionList
                key={selectedClientId}
                onClose={() => setActivePopup('')}
                onSave={(text) => {
                    setActivePopup('');
                }}
                onSaveDraft={() => { }}
                sessions={selectedClientSessionsArray}
                onAdd={() => {
                    setActivePopup('AddSession')
                }}
                onEdit={(session) => {
                    // Pass the session to be edited
                    setSelectedSessionForEdit(session);
                    setActivePopup('AddSession');
                    setSelectedSessionForEdit(session);
                    setActivePopup('AddSession');
                }}
            ></FullSessionList>
        }
    </>
}